import { FC } from 'react';
import { useAssetType } from 'src/context-providers/asset-type/AssetTypeContext';
import { AssetType } from 'src/models';

interface Props {
  children: JSX.Element | (boolean | JSX.Element)[] | string | undefined | null | boolean;
  /** Allowed asset types. */
  supported: AssetType | AssetType[];
}

export const AssetTypeConditional: FC<Props> = ({ supported, children }) => {
  const { assetType } = useAssetType();
  const isSupported =
    (typeof supported === 'string' && assetType === supported) || (Array.isArray(supported) && supported.includes(assetType));

  return <>{isSupported && children}</>;
};
